module.exports = __webpack_public_path__ + "media/images/redesign-images/fraternity-new/header-image-mobile-02-cab9b3693667f665ce74c572394079e9.jpg";